export const getTXRoofSurfacesExtended = (
  roofAge: number,
  deductibleWindHail: number,
  coverageRSExtended?: boolean
): Record<'coverageRSExtended' | 'stateSpecificLockField' | 'stateOverride' | 'roofAgeLimit', any> => {
  if (deductibleWindHail > 1) {
    // if higher than 1, member is paying a flat wind/hail deductible, these always force roof schedule
    return { coverageRSExtended: false, stateSpecificLockField: true, stateOverride: true, roofAgeLimit: 0 };
  }

  // force roof schedule based on age and wind/hail deductible

  if (deductibleWindHail === 0.01 && roofAge >= 4) {
    return { coverageRSExtended: false, stateSpecificLockField: true, stateOverride: true, roofAgeLimit: 3 };
  }

  if (deductibleWindHail === 0.02 && roofAge >= 7) {
    return { coverageRSExtended: false, stateSpecificLockField: true, stateOverride: true, roofAgeLimit: 6 };
  }

  // all others can pick between schedule or extended roof coverage
  return {
    coverageRSExtended: !!coverageRSExtended,
    stateSpecificLockField: false,
    stateOverride: true,
    roofAgeLimit: 99
  };
};

export const getOKRoofSurfacesExtended = (
  roofAge: number,
  deductibleWindHail: number,
  coverageRSExtended?: boolean
): Record<'coverageRSExtended' | 'stateSpecificLockField' | 'stateOverride' | 'roofAgeLimit', any> => {
  if (deductibleWindHail > 1) {
    // if higher than 1, member is paying a flat wind/hail deductible, these always force roof schedule
    return { coverageRSExtended: false, stateSpecificLockField: true, stateOverride: true, roofAgeLimit: 0 };
  }

  // force roof schedule based on age and wind/hail deductible
  // UNLESS: 5% deductible OR (1% and roof age 0-3) OR (2% and roof age 0-6)

  if (deductibleWindHail === 0.05) {
    // 5% wind/hail deductible - no roof schedule required regardless of age
    return {
      coverageRSExtended: !!coverageRSExtended,
      stateSpecificLockField: false,
      stateOverride: true,
      roofAgeLimit: 99
    };
  }

  if (deductibleWindHail === 0.01 && roofAge >= 4) {
    // 1% deductible with roof age 4+ requires roof schedule
    return { coverageRSExtended: false, stateSpecificLockField: true, stateOverride: true, roofAgeLimit: 3 };
  }

  if (deductibleWindHail === 0.02 && roofAge >= 7) {
    // 2% deductible with roof age 7+ requires roof schedule
    return { coverageRSExtended: false, stateSpecificLockField: true, stateOverride: true, roofAgeLimit: 6 };
  }

  // all others can pick between schedule or extended roof coverage
  return {
    coverageRSExtended: !!coverageRSExtended,
    stateSpecificLockField: false,
    stateOverride: true,
    roofAgeLimit: 99
  };
};
